import { activityLogModel } from "./.."; // entry

export const id = _ref => {
  let {
    id
  } = _ref;
  return id;
};
export const timestamp = _ref2 => {
  let {
    timestamp
  } = _ref2;
  return timestamp;
};
export const type = _ref3 => {
  let {
    type
  } = _ref3;
  return type;
};
export const vendor = _ref4 => {
  let {
    data
  } = _ref4;
  return data === null || data === void 0 ? void 0 : data.vendor;
};
export const vendorName = _ref5 => {
  var _data$vendor;

  let {
    data
  } = _ref5;
  return data === null || data === void 0 ? void 0 : (_data$vendor = data.vendor) === null || _data$vendor === void 0 ? void 0 : _data$vendor.name;
};
export const customer = _ref6 => {
  let {
    data
  } = _ref6;
  return data === null || data === void 0 ? void 0 : data.customer;
};
export const customerName = _ref7 => {
  var _data$customer;

  let {
    data
  } = _ref7;
  return data === null || data === void 0 ? void 0 : (_data$customer = data.customer) === null || _data$customer === void 0 ? void 0 : _data$customer.name;
}; // agreement

export const agreementState = _ref8 => {
  let {
    state
  } = _ref8;
  return state;
};
export const agreementChannel = agreementEntry => agreementEntry.data.channel;
export const agreementChangesNetTerms = _ref9 => {
  var _data$changes;

  let {
    data
  } = _ref9;
  return (_data$changes = data.changes) === null || _data$changes === void 0 ? void 0 : _data$changes.netTerms;
};
export const agreementChangesApprovalMethod = _ref10 => {
  var _data$changes2;

  let {
    data
  } = _ref10;
  return (_data$changes2 = data.changes) === null || _data$changes2 === void 0 ? void 0 : _data$changes2.amendmentsApprovalMethod;
};
export const agreementChangesTitle = _ref11 => {
  var _data$changes3;

  let {
    data
  } = _ref11;
  return (_data$changes3 = data.changes) === null || _data$changes3 === void 0 ? void 0 : _data$changes3.title;
};
export const agreementChangesManualPayments = _ref12 => {
  var _data$changes4;

  let {
    data
  } = _ref12;
  return (_data$changes4 = data.changes) === null || _data$changes4 === void 0 ? void 0 : _data$changes4.manualPayments;
};
export const agreementChangesCoverCCFees = _ref13 => {
  var _data$changes5;

  let {
    data
  } = _ref13;
  return (_data$changes5 = data.changes) === null || _data$changes5 === void 0 ? void 0 : _data$changes5.coverCreditCardFees;
};
export const agreementPaymentMethod = _ref14 => {
  let {
    data
  } = _ref14;
  return data.paymentMethod;
};
export function isReminderEntry(entry) {
  return type(entry) === activityLogModel.Type.Relationship && [activityLogModel.AgreementState.SigningReminderSent, activityLogModel.AgreementState.SigningReminderSentManual, activityLogModel.AgreementState.MicroDepositReminderSent].includes(entry.state);
} // invoice

export const invoiceState = _ref15 => {
  let {
    state
  } = _ref15;
  return state;
};
export const invoiceId = _ref16 => {
  let {
    data
  } = _ref16;
  return data.invoice.id;
};
export const invoiceFormattedNumber = _ref17 => {
  let {
    data
  } = _ref17;
  return data.invoice.formattedNumber;
};
export const invoiceTotalAmount = _ref18 => {
  let {
    data
  } = _ref18;
  return data.invoice.totalAmount;
}; // charge

export const chargeState = _ref19 => {
  let {
    state
  } = _ref19;
  return state;
};
export const chargePrice = _ref20 => {
  let {
    data
  } = _ref20;
  return data.charge.price;
};
export const charge = _ref21 => {
  let {
    data
  } = _ref21;
  return data.charge;
};
export const chargeNote = _ref22 => {
  let {
    data
  } = _ref22;
  return data.charge.note;
}; // service

export const serviceState = _ref23 => {
  let {
    state
  } = _ref23;
  return state;
};
export const service = _ref24 => {
  let {
    data
  } = _ref24;
  return data.service;
};
export function isAgreementEntry(entry) {
  return type(entry) === activityLogModel.Type.Relationship;
}